<template>
  <div class="container">
    <app-header title="我的求购"/>
    <div class="upimg">
      <van-uploader
        :deletable='false'
        :max-count='fileList.length'
        :file-list="fileList"
        :after-read="afterRead"
        @delete='deleteImg'
        />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader } from 'vant'
import { uploadimage } from '@/api/file.js'
import { getShopPurchaseList } from '@/api/purchase/index.js'
Vue.use(Uploader)
export default {
  data() {
    return {
      fileList: []
    }
  },
  created() {
    this._getShopPurchaseList()
  },
  methods: {
    // 上传成功之后
    afterRead(file) {
      uploadimage(file.file).then((res) => {
        if (res.success) {
          this.fileList.push({ url: res.data })
        }
      })
    },
    _getShopPurchaseList() {
      var user = localStorage.getItem("userInfo")
      if (!user){
        this.$toast.fail('请登录')
        return;
      }
      const params = {
        type: this.$route.query.activeTag,
        uid: this.$store.getters.id
        // fileType: 2
      }
      getShopPurchaseList(params).then((res) => {
        if (res.success) {
          this.fileList = []
          res.data.forEach((item) => {
            if (item.fileType == 1) {
              this.fileList.push({ url: JSON.parse(item.file)[0].url })
            }
          })
        }
      })
    },
    // 删除图片
    deleteImg(e) {
      this.fileList.splice(0, 1)
    }
  }
}
</script>

<style scoped>
  .upimg{
    box-sizing: border-box;
    padding: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/buy/buyImages.vue